// @flow

import React, { memo, useMemo, useEffect } from 'react'
import QRCodeGenerator from 'qrcode.react'
import { useTranslation } from 'react-i18next'

import { useFocusable, FocusContext } from '@alphaott/smart-tv-spatial-navigation'
import { Button } from '@alphaott/smart-tv-components'
import { SCREEN_FOCUS_KEYS } from '@alphaott/smart-tv-config'

import {
  PageView,
  Row,
  LeftColumn,
  RightColumn,
  Header,
  Title,
  Description,
  Logo,
  Content,
  QRHeading,
  LinkText,
  StyledIcon,
  QRCodeContainer,
} from './elements'

import { CheckIcon } from '../assets'

import { SUPPORT_BUTTON_FOCUS_KEY } from '../const'

type WelcomeViewProps = {
  logoSrc: string,
  logoHeight: number,
  onSupport: Function,
  link: string,
  description?: string,
}

const QRCodeStyles = { width: '350rem', height: '350rem' }
const SCREEN_FOCUS_KEY = SCREEN_FOCUS_KEYS.WELCOME

const WelcomeViewPure = ({
  logoSrc,
  logoHeight,
  onSupport,
  link,
  description = 'mwstv_notifications_welcome_message',
}: WelcomeViewProps) => {
  const { ref, focusKey, setFocus } = useFocusable()
  const { t } = useTranslation()

  const uri = useMemo(() => link || '', [link])

  useEffect(() => {
    setFocus(SUPPORT_BUTTON_FOCUS_KEY)
  }, [setFocus])

  return (
    <FocusContext.Provider value={focusKey}>
      <PageView focusKey={SCREEN_FOCUS_KEY} ref={ref}>
        <Header>
          <Logo src={logoSrc} height={logoHeight} alt="logo" />
        </Header>
        <Content>
          <Row>
            <LeftColumn>
              <Title>
                <StyledIcon as={CheckIcon} />
                {t('welcome')}
              </Title>
              <Description>{t(description)}</Description>
              <LinkText>{link}</LinkText>
            </LeftColumn>

            {uri && (
              <RightColumn>
                <QRHeading>{t('mwstv_notifications_qr_code_heading')}</QRHeading>
                <QRCodeContainer>
                  <QRCodeGenerator style={QRCodeStyles} value={uri} />
                </QRCodeContainer>
              </RightColumn>
            )}
          </Row>
          <Row>
            <div>
              <Button focusKey={SUPPORT_BUTTON_FOCUS_KEY} onClick={onSupport}>
                {t('support')}
              </Button>
            </div>
            <div />
          </Row>
        </Content>
      </PageView>
    </FocusContext.Provider>
  )
}

export const WelcomeView = memo<WelcomeViewProps>(WelcomeViewPure)

export default WelcomeView
